var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgHeartPulseColor = function SvgHeartPulseColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 60 60",
    "aria-hidden": true,
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#DCF3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078bc",
    d: "m33.02 29.425-2.344 4.687c-.281.562-1.078.515-1.359-.047l-2.672-5.906-1.406 3.328h-4.405l8.577 8.765a.82.82 0 0 0 1.171 0l8.578-8.765h-5.11l-1.03-2.062Zm7.17-7.968-.093-.094a6.14 6.14 0 0 0-8.812 0l-1.265 1.312-1.312-1.312a6.14 6.14 0 0 0-8.812 0l-.094.094c-2.296 2.343-2.39 6.046-.328 8.53h4.781l1.687-4.03c.235-.61 1.078-.61 1.36 0l2.718 6.045 2.297-4.593a.758.758 0 0 1 1.359 0l1.312 2.578h5.578c2.015-2.484 1.921-6.187-.375-8.53Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeartPulseColor);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;